import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { Lock } from 'lucide-react';
import type { AppViewFilter } from '@diggens/types/apps';
import { fixedFilterChipLabel, type ChipLabelSources } from '../../features/views';

interface FixedFilterChipsProps {
  filters: ReadonlyArray<AppViewFilter>;
  sources: ChipLabelSources;
}

/**
 * The fixed filters of an app view as read-only chips, so a reader sees why rows or cards are missing. They have no
 * delete control: the view declares them and the API applies them whatever the reader filters on top.
 */
export function FixedFilterChips({ filters, sources }: FixedFilterChipsProps) {
  if (filters.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }} data-testid="fixed-filters">
      <Typography variant="caption" color="text.secondary">
        Showing only
      </Typography>
      {filters.map((filter, index) => (
        <Tooltip key={`${filter.field}-${filter.op}-${index}`} title="Set by this view; add your own filters on top">
          <Chip size="small" variant="outlined" icon={<Lock size={12} />} label={fixedFilterChipLabel(filter, sources)} />
        </Tooltip>
      ))}
    </Box>
  );
}
